/** @file Guard: bones generated by a socket (kind socket/socketGrip2) are edited through their socket only. */
import type { Doc, Id } from '@pose2d/format/types';
import { throwError } from '@pose2d/format/throwError';

/** Throws VALIDATION at `target` when `boneId` is a generated socket bone; a missing bone is left to the resolver. */
export function assertNotSocketBone(doc: Doc, boneId: Id): void {
  const kind = doc.bones[boneId]?.kind;
  if (kind === 'socket' || kind === 'socketGrip2') throwError('VALIDATION', undefined, { path: 'target', hint: 'generated socket bone: edit the socket instead' });
}
